import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import WhyUs from "@/components/WhyUs";
import HowItWorks from "@/components/HowItWorks";
import LugoSection from "@/components/LugoSection";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export const Landing = () => (
    <div className="bg-cream text-ink overflow-x-clip">
        <Navbar />
        <main>
            <Hero />
            <Marquee />
            <Services />
            <WhyUs />
            <HowItWorks />
            <LugoSection />
            <Contact />
        </main>
        <Footer />
    </div>
);

export default Landing;
